import useSWR from 'swr';
import { api } from '@/App';

const fetcher = (url) => api.get(url).then((res) => res.data);

/**
 * Public feature flags set from Admin -> Settings -> Feature Toggles.
 * `loaded` is false until the first fetch resolves so gates can avoid
 * flashing the wrong state. Defaults are OFF on a fresh database.
 */
export function useFeatures() {
  const { data, error } = useSWR('/features', fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 15000,
  });
  return { features: data || {}, loaded: !!data || !!error };
}
